<section fxLayout="column" class="main">
  <section>
    <p class="grey-label">{{'libraries.edit.folders.no_policy.first'|translate}}</p>
    <p class="grey-label">{{'libraries.edit.folders.no_policy.second'|translate}}</p>
  </section>
  <section>
    <button mat-button (click)="open()" [disabled]="isError">  {{'libraries.edit.folders.button.first_assign'|translate}}</button>
  </section>
</section>
